import { render, staticRenderFns } from "./ProposedLifeInsuredCN.vue?vue&type=template&id=f96845b0"
import script from "./ProposedLifeInsuredCN.vue?vue&type=script&lang=js"
export * from "./ProposedLifeInsuredCN.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports